<div class="card">
  <div class="card-header">
    <h4 class="card-title float-left" id="basic-layout-form">{{ 'modules.title' | translate }}</h4>
    <div class="clear-float-left"></div>
    <br>
    <input type='text' class="form-control form-control-sm filter-input"
           placeholder="{{'modules.filterByNamePlaceHolder' | translate}}" (keyup)='searchFilter($event)'/>
    <app-boolean-toggle-filter class="d-none d-md-block filter-input"
                               [booleanToggleFilterText]="'modules.showInActiveText' | translate"
                               (booleanToggleFilterChangedEvent)="handleBooleanToggleFilterChanged($event)"></app-boolean-toggle-filter>
  </div>
  <div class="card-body">
    <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
      <table
        [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
        <thead>
        <tr>
          <th *ngFor="let field of fieldCollection"
              [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
              (click)="sort(field.canSort, field.name)">{{ field.displayName | translate }}
          </th>
          <th>{{ 'modules.actionsFieldTitle' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let module of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
          <ng-template [ngIf]="module.IsActive">
            <td><i class="circle bg-green"></i></td>
          </ng-template>
          <ng-template [ngIf]="!module.IsActive">
            <td><i class="circle bg-red"></i></td>
          </ng-template>
          <td class="d-none d-lg-table-cell">{{ module.ModuleId }}</td>
          <td class="col-sm-5 col-5">{{ module.Name }}</td>
          <td class="d-none d-sm-table-cell">{{ module.DefaultTransactionFeeCurrency }}</td>
          <td class="d-none d-lg-table-cell">{{ module.DefaultRefundCostCurrency }}</td>
          <td>
            <a *ngIf="sectionPermission.CanEdit" class="success" data-original-title=""
               title="{{'modules.editModuleTitle' | translate: module}}" (click)="openEditModal(module)">
              <i class="ft-edit-2 font-medium-3"></i>
            </a>
            <a *ngIf="sectionPermission.CanActivate && !module.IsActive" class="succes" data-original-title=""
               title="{{'modules.activateModuleTitle' | translate: module}}" (click)="activate(module)">
              <i class="ft-check font-medium-3 ml-1"></i>
            </a>
            <a *ngIf="sectionPermission.CanDeactivate && module.IsActive" class="danger" data-original-title=""
               title="{{'modules.deactivateModuleTitle' | translate: module}}" (click)="deactivate(module)">
              <i class="ft-eye-off font-medium-3 ml-1"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize"
                           (pageChange)="pageChanged($event)" id="server"
                           previousLabel="{{'pagination.previousLabel' | translate}}"
                           nextLabel="{{'pagination.nextLabel' | translate}}">
      </pagination-controls>
    </div>
  </div>
</div>
